const SUPPORT_AI_OPERATIONS_READ = 'support.ai.operations.read' as const;

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

/**
 * Project the one capability needed by the Operations workspace.
 * Missing, stale, unavailable, or malformed context is always denied.
 */
export function hasSupportAIOperationsAccess(value: unknown): boolean {
  if (!isRecord(value) || value.available !== true || !isRecord(value.capabilities)) return false;

  const capability = value.capabilities[SUPPORT_AI_OPERATIONS_READ];
  return (
    isRecord(capability) &&
    capability.granted === true &&
    capability.risk_level === 'read' &&
    capability.step_up_required === false
  );
}

